import Vue from "vue"
import * as rt from "../../../routes/routes"
import * as ers from "../../../errorsmessages/errors"
import * as suc from "../../../successmessages/success"
import * as ses from "../../../configurations/session/sessioncomplete"
import baseurl from "../../../configurations/baseurl/baseurl"

export const actions = {

    newModule() {
        let module = {
            modulename: $('.modulename').val()
        }
        $('.creatingModuleLoader').show()
        $('.creatingModule').hide()
        baseurl
            .post(rt.newModules, module)
            .then(res => {
                $('.creatingModuleLoader').hide()
                $('.creatingModule').show()
                $('.form-control').val("")
                if (res.data.code === 200) {
                    suc.moduleCreateSuccess()
                } else if (res.data.code === 403) {
                    ers.moduleExists()
                } else if (res.data.code === 404) {
                    ers.errorCreatingModule()
                } else if (res.data.code === 506) {
                    ses.sessionComplete()
                }
            })
    },


    loadModules({ commit }) {
        baseurl
            .get(rt.loadModules)
            .then(res => {
                $('.modulesLoader').hide()
                $('.rolemodulesLoader').hide()
                if (res.data.code === 200) {
                    commit('STORE_ROLE_MODULES', res.data.modules)
                } else if (res.data.code === 404) {
                    ers.errorLoadingModules()
                } else if (res.data.code === 506) {
                    ses.sessionComplete()
                }

            })
    },


    deleteModule({commit}, moduleId) {
        Vue.swal.fire({ title: 'Are you sure?', text: 'You want to delete this module..?!', type: "warning", showCancelButton: true }).then(result => {
            if (result.value) {
                window.$("#modulesLoaderModal").modal("show");
                baseurl
                    .get(rt.deleteModule + moduleId)
                    .then(res => {
                        window.$("#modulesLoaderModal").modal("hide");
                        if (res.data.code === 200) {
                            suc.moduleDeleteSuccess()
                            setTimeout(() => {
                                $('.modulesLoader').show()
                                setTimeout(() => {
                                    commit('STORE_ROLE_MODULES', res.data.modules)
                                    $('.modulesLoader').hide()
                                }, 200);

                            }, 3000);

                        } else if (res.data.code === 404) {
                            ers.errorDeletingModule()
                        } else if (res.data.code === 506) {
                            ses.sessionComplete()
                        }

                    })
            } 
        })
    }
}

export default actions


// WEBPACK FOOTER //
// ./src/vuex/modules/rolemodules/actions.js